var map = {
	"./Burn.json": 78919,
	"./ERC20.json": 67489,
	"./Game.json": 59260,
	"./NFT.json": 65351,
	"./NFTMarketV2.json": 86682,
	"./PacmanNFTGen0.json": 61875,
	"./PacmanNFTGen1.json": 35328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55463;